import React from 'react';
import { formatDate, formatRelativeTime } from '../lib/utils';

/**
 * Renders a future gig date plus a muted relative-time hint, e.g.
 *   "Tue 5 May · in 7 days"
 *   "Sat 12 Apr · tomorrow"
 *
 * The relative hint is dropped automatically for past dates 30+ days old.
 *
 * Props:
 *   date          ISO date string (YYYY-MM-DD or full ISO)
 *   relativeColor CSS color for the muted hint (default 'var(--t3)')
 */
export function DateWithRelative({ date, relativeColor = 'var(--t3)' }) {
  if (!date) return null;
  const rel = formatRelativeTime(date);
  return (
    <>
      {formatDate(date)}
      {rel && (
        <span style={{ color: relativeColor }} data-testid="relative-time-hint">
          {' · '}{rel}
        </span>
      )}
    </>
  );
}

export default DateWithRelative;
